export default __webpack_public_path__ + "static/media/no-image.bd33161f.svg";